/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import {
	Menu,
	Dropdown,
	Button,
	Space,
	Tooltip,
	Typography,
	Avatar,
	Row,
	Col,
} from "antd";
import {
	CheckCircleTwoTone,
	DeleteOutlined,
	DownOutlined,
	SearchOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { isEmpty, filter, map, find } from "lodash";
import { primaryDark } from "../../GlobalConfig";
import { accountBaseUrl } from "../../helpers/account";

function ProfessionalSelectList({
	item,
	appointmentReasonId,
	practitionerId,
	toggleItem,
	themeColor,
	availabilityRequests,
}) {
	const history = useHistory();
	const [filteredPractitioners, setFilteredPractitioners] = React.useState(item?.displayPractitioners);
	const practiceId = useSelector((state) => state.locations.currentLocation?.id);

	React.useEffect(() => {
		if (practitionerId) {
			const filteredPractitioners = item?.displayPractitioners?.filter((practitioner) =>
				practitioner.id.toString() === practitionerId,
			);
			setFilteredPractitioners(filteredPractitioners);
		}
	}, [item, practitionerId]);

	const menu = (
		<Menu>
			<Menu.ItemGroup title="Make selection" />
			<Menu.Item
				icon={
					<Avatar style={{ background: themeColor ? themeColor : "black" }}>
						<SearchOutlined />
					</Avatar>
				}
				key="0"
				onClick={() => {
					const anyBatch = Date.now();
					map(filteredPractitioners, ({ id }) =>
						toggleItem({
							reasonId: appointmentReasonId,
							practitionerId: id,
							anyBatch,
						}),
					);

					history.push(`${accountBaseUrl}/locations/${practiceId}/date`);
				}}
			>
				First Available
			</Menu.Item>
			{filteredPractitioners?.map(({ id, name, photo }) => (
				<Menu.Item
					icon={
						photo ? (
							<Avatar src={photo} />
						) : (
							<Avatar style={{ background: primaryDark }}>
								<UserOutlined />
							</Avatar>
						)
					}
					key={id}
					onClick={() => {
						toggleItem({
							reasonId: appointmentReasonId,
							practitionerId: id,
						});

						history.push(`${accountBaseUrl}/locations/${practiceId}/date`);
					}}
				>
					{name}
				</Menu.Item>
			))}
		</Menu>
	);

	const matchingRequests = filter(
		availabilityRequests,
		({ reasonId }) => appointmentReasonId === reasonId,
	);
	const isAnyRequest = filter(
		matchingRequests,
		({ anyBatch }) => anyBatch,
	).length;

	const requests = map(
		matchingRequests,
		({ practitionerId }) => practitionerId,
	);
	const practitioner = find(filteredPractitioners, ({ id }) => requests.includes(id));
	const isSelected = practitioner;

	return (
		<>
			{isSelected ? (
				<Row justify="space-between">
					<Col>
						{isAnyRequest ? (
							<span>
								<CheckCircleTwoTone
									twoToneColor={{ color: themeColor ? themeColor : "#ccc" }}
									className="mr-sm"
								/>
								Anyone
								<br />
							</span>
						) : (
							<span>
								<CheckCircleTwoTone
									twoToneColor={{ color: themeColor ? themeColor : "#ccc" }}
									className="mr-sm"
								/>
								{practitioner?.title} {practitioner?.name}
								<br />
							</span>
						)}
					</Col>
					<Col>
						<Tooltip title="Remove Selection">
							<Typography.Link
								style={{ color: "#000" }}
								onClick={() =>
									toggleItem({
										reasonId: appointmentReasonId,
										practitionerId: requests[0],
									})
								}
							>
								<Space>
									<DeleteOutlined />
									Clear selection
								</Space>
							</Typography.Link>
						</Tooltip>
					</Col>
				</Row>
			) : (
				<Dropdown
					overlay={menu}
					trigger={["click"]}
					disabled={!isEmpty(availabilityRequests)}
				>
					<Button
						disabled={!isEmpty(availabilityRequests)}
						block
						onClick={(e) => e.preventDefault()}
					>
						Select <DownOutlined />
					</Button>
				</Dropdown>
			)}
		</>
	);
}
export default ProfessionalSelectList;
